"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestBalanceDetails = void 0;
var lodash_1 = require("lodash");
var getLatestBalanceDetails = function (data) {
    var onlyStatementAvailable = (data === null || data === void 0 ? void 0 : data.billablePeriods)
        ? data === null || data === void 0 ? void 0 : data.billablePeriods.filter(function (period) { return period.isStatementAvailable === true; })
        : [];
    if (onlyStatementAvailable.length > 0) {
        var sorted = (0, lodash_1.sortBy)(onlyStatementAvailable, 'end').reverse();
        return {
            endDate: sorted[0].end,
            amount: sorted[0].closingBalance.pounds,
        };
    }
    else {
        return null;
    }
};
exports.getLatestBalanceDetails = getLatestBalanceDetails;
